<template>
  <Card class="custom-card border-b-4 border-h-primary-800 p-4 mt-4">
    <template #header>
      <h6>{{ $t("labels.generic", { pt: "Corretas", en: "Corrects" }) }}</h6>
    </template>
    <template #content>
      <div class="flex flex-row gap-3 flex-wrap">
        <p class="response" v-for="(response, index) in responses" :key="index">
          {{ response.name }}
        </p>
      </div>
    </template>
  </Card>
</template>
<script lang="ts">
import { defineComponent, PropType } from "vue";
import { GapInput } from "./FormItems.vue";
export default defineComponent({
  name: "response-card",
  props: {
    responses: {
      type: Array as PropType<Array<GapInput>>,
    },
  },
});
</script>
<style lang="scss">
.custom-card {
  .response {
    background-color: #f6fafd;
    border-radius: 0.4rem;
    border: 1px solid #79b5e1;
    box-decoration-break: clone;
    color: #79b5e1;
    padding: 0.1rem 0.3rem;
    width: fit-content;
    word-break: break-all;
    display: flex;
    flex-wrap: wrap;
  }
}
</style>
